import { createSlice } from '@reduxjs/toolkit';

import { updateSingleAppointment } from '../providerAppointments';

const initialState = {
  actions: [],
  animal: {},
  datePaid: '',
  dateStart: '',
  isLoading: false,
  note: '',
  service: {},
  status: {},
  summary: {},
  user: {},
};

const appointment = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    appointmentRequest(state) {
      state.isLoading = true;
    },
    appointmentSuccess(state, { payload }) {
      return {
        isLoading: false,
        ...payload.data,
      };
    },
    appointmentFailure(state) {
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateSingleAppointment, (state, { payload }) => ({
      isLoading: false,
      ...payload.data,
    }));
  },
});

const { actions, reducer } = appointment;

export const { appointmentRequest, appointmentSuccess, appointmentFailure } =
  actions;

export default reducer;
